import type { AxiosInstance } from 'axios';
import { BaseService } from './BaseService';
import type { BrandCategoryViewModel, BrandCategoryCreateModel, BrandCategoryUpdateModel } from '../types/brand-category';
import { apiClient } from '../client/client';

export class BrandCategoryService extends BaseService<
  BrandCategoryViewModel,
  BrandCategoryCreateModel,
  BrandCategoryUpdateModel,
  BrandCategoryViewModel[]
> {
  private static readonly BASE = '/api/brand-category';

  constructor(client: AxiosInstance = apiClient) {
    super(client, BrandCategoryService.BASE);
  }
}

export const brandCategoryService = new BrandCategoryService();
